import { createComponent } from '@carvana/merch-components';
import classNames from 'classnames';
import React from 'react';

type TTag = 'deal' | 'ev' | 'hold' | 'locked' | 'price' | 'reservable';

type OwnProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  text: string;
  border?: boolean;
  bigTag?: boolean;
  blueText?: boolean;
  tag: TTag;
};

const bgColorMap = {
  deal: 'bg-blue-4',
  ev: 'bg-grey-1',
  hold: 'bg-yellow-3',
  locked: 'bg-red-2',
  price: 'bg-green-2',
  reservable: 'bg-blue-2'
};

const Wrapper = createComponent('div', {
  className:
    'flex font-bold h-20 items-center leading-5 px-4 rounded text-xs w-fit'
});

const Tag = ({
  border = false,
  text,
  bigTag = false,
  blueText = false,
  tag,
  ...props
}: OwnProps) => (
  <Wrapper
    className={classNames(
      `${bgColorMap[tag]} ${blueText ? 'text-blue-6' : 'text-white'}`,
      { '!py-8 !px-16 !text-sm !h-24 leading-6': bigTag },
      { 'border border-grey-3': border }
    )}
    {...props}
  >
    {text}
  </Wrapper>
);

export default Tag;
